<template>
    <div>
      <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right mt-2">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
            <h4 class="page-title">Selamat Datang Di E-Retribusi , <br>{{ $store.state.userData ? $store.state.userData.name : '-' }}</h4>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <ItemReport 
          name="Kategori Retribusi" :total="totalService" 
          icon="dripicons-wallet" color="text-pink"/>
        </div>

        <div class="col-lg-4" v-if="$store.state.userData.role_name != 'COMPANY OPERATOR'">
          <ItemReport 
          name="Wajib Retribusi" :total="totalCustomer" 
          icon="dripicons-user-group" color="text-success"/>
        </div>

        <div class="col-lg-4">
          <ItemReport 
          name="Transaksi" :total="currency(totalTransaction)" 
          icon="dripicons-cart" color="text-secondary"/>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-lg-12">
          <div class="card">
              <div class="card-body">
                  <div class="float-right eco-revene-history justify-content-end">
                      <ul class="nav">
                          <li class="nav-item">
                              <a class="nav-link active" href="#">Today</a>
                          </li>
                          <li class="nav-item">
                              <a class="nav-link" href="#">Yesterday</a>
                          </li>
                          <li class="nav-item">
                              <a class="nav-link" href="#">Last Week</a>
                          </li>                                     
                      </ul>
                  </div>
                  <h4 class="header-title mt-0">Transaksi</h4>
                  <div class="apexchart-wrapper">
                      <div id="chart-dashboard" class="chart-gutters"></div>
                  </div>
              </div>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="mt-0 mb-3 header-title">Transaksi Terakhir</h4>
              <div class="row">
                <div class="col-sm-12">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th>Invoice Code</th>
                          <th>Kategori Retribusi</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in transactions" :key="item.id">
                          <td>{{item.invoice_code}}</td>
                          <td>
                            <span v-for="(service, index) in item.service_name" :key="service+index">
                                {{service}}
                                <template v-if="index != item.service_name.length - 1">, </template>
                            </span>
                          </td>
                          <td>{{ currency(item.total) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ItemReport from '@/components/dashboard/ItemReport'

import ApexCharts from 'apexcharts'
export default {
  data(){
    return {
      totalService: 0,
      totalCustomer: 0,
      totalTransaction: 0,
      transactions: [],
    }
  },
  components: {
    ItemReport
  },
  methods: {
  },
  async mounted() {
    // GET SERVICE
    const dashboard = await this.$http.get(`${this.API_URL}dashboard?type=company`, {
        headers: { 
            'Authorization': `Bearer ${this.$cookies.get("token_instance")}`
        }
    })
    
    // GET TRANSACTION
    const transaction = await this.$http.get(`${this.API_URL}transaction`, {
        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
    })

    this.totalService = dashboard.data.service
    this.totalCustomer = dashboard.data.customer
    this.totalTransaction = dashboard.data.transaction
    this.transactions = transaction.data.data.slice(0, 5);
  }
}
</script>

<style>

</style>